var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExclamation = function SvgExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12a9 9 0 0 1-9 9 9 9 0 0 1-9-9c0-4.969 4.03-9 9-9s9 4.031 9 9Zm-9 1.815a1.67 1.67 0 1 0 0 3.338 1.67 1.67 0 0 0 0-3.338Zm-1.316-1.066-.269-4.935a.435.435 0 0 1 .435-.46h2.3c.25 0 .448.21.435.46l-.27 4.935a.435.435 0 0 1-.434.412h-1.762a.435.435 0 0 1-.435-.412Z",
    fill: "currentColor"
  })));
};

export default SvgExclamation;